import { render, staticRenderFns } from "./backoffice-footer.vue?vue&type=template&id=2f96a96c&"
import script from "./backoffice-footer.vue?vue&type=script&lang=js&"
export * from "./backoffice-footer.vue?vue&type=script&lang=js&"
import style0 from "./backoffice-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports